import * as React from 'react'
import { attachGDPREvent } from 'lib/CookieGDPR/attachGDPREvent'
import { GeneralTrackingHelper } from 'lib/Tracking'
import { setCurrentVersion } from 'lib/setCurrentVersion'

declare global {
  interface Window {
    GeneralTrackingHelper: typeof GeneralTrackingHelper
  }
}

setCurrentVersion()

if (!window.GeneralTrackingHelper) {
  Object.defineProperty(window, 'GeneralTrackingHelper', {
    value: GeneralTrackingHelper
  })
}

attachGDPREvent()
